import { render } from "./StandardPayment.vue?vue&type=template&id=70179734&scoped=true"
import script from "./StandardPayment.vue?vue&type=script&steup=true&lang=js"
export * from "./StandardPayment.vue?vue&type=script&steup=true&lang=js"

import "./StandardPayment.vue?vue&type=style&index=0&id=70179734&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70179734"]])

export default __exports__